
import axios from 'axios'; 

const url = 'https://covid19.mathdro.id/api';

export const fetchData = async(country)=>{
    let ChangeableUrl = url;
    if(country){
        ChangeableUrl = `${url}/countries/${country}`;
    }


    try {
        const {data:{confirmed,recovered,deaths,lastUpdate}} =await axios.get(ChangeableUrl);
    return { confirmed, recovered, deaths, lastUpdate };
    }catch(err){
        return 'some error with server...'

    }
}

export const fetchDailyData = async ()=>{
    try{
        const {data} = await axios.get(`${url}/daily`);
     //console.log(data)
        const modifiedData = data.map((dailyData)=>({
            confirmed:dailyData.confirmed.total,
            deaths:dailyData.deaths.total,
            date:dailyData.reportDate
        }))

        return modifiedData;
    }catch(error){

    }
} 


export const fetchCountries = async ()=>{
    try {
        const {data:{countries}} = await axios.get(`${url}/countries`)
        const res= countries.map((country)=>country.name);
        return res
    }
    catch(error){
        console.log(error);

    }
}